export const learningUiLabels = [
  "Back",
  "Open teaching presentation",
  "Projector slide",
  "No presentation slides available.",
  "Slide content unavailable.",
  "Audio unavailable",
  "Playing",
  "Play audio",
  "Stop audio",
  "Audio playback is unavailable for this clip in the current browser.",
  "Pause {{label}}",
  "Play {{label}}",
  "Select slide {{index}}: {{label}}. Drag to reorder, or use Alt plus Arrow Up or Arrow Down.",
  "Actions for slide {{index}}",
  "Hidden",
  "Show slide",
  "Hide slide",
  "Duplicate slide",
  "Remove slide",
  "Lesson",
  "cards",
  "text",
  "image",
  "Slides",
  "{{count}} visible",
  "Presentation stage",
  "Popup blocked · preview only",
  "Live sync unavailable · preview only",
  "Projector connected",
  "Projector opening",
  "Preview ready",
  "Hide translation",
  "Reveal translation",
  "Hide answers",
  "Reveal answers",
  "Previous slide",
  "Next slide",
  "Waiting for controller…",
  "Presentation ended.",
  "Exit teaching presentation",
  "Hide slides",
  "Show slides",
  "Presentation connection status",
  "Open projector",
  "Resize slide rail",
  "Flashcard categories",
  "Open {{category}} flashcard category",
  "Open this flashcard category to curate cards, start a slideshow, or launch a game session.",
  "Preparing flashcards",
  "Keep this page open while we prepare the selected category.",
  "Flashcard categories failed to load. Please try again.",
  "Preparing flashcard categories",
  "Keep this page open while we load the categories you can practice.",
  "We could not load flashcard categories",
  "Dismiss",
  "No flashcard categories are available yet",
  "The categories request completed, but no published flashcard categories are available yet.",
  "Back to categories",
  "Slide show",
  "Collection ({{count}})",
  "Play game",
  "Selected",
  "Preview in slideshow",
  "Remove from collection",
  "Add to collection",
  "Preparing this flashcard set",
  "Keep this page open while we load the cards for this category.",
  "We could not load this flashcard set",
  "No flashcards are available in this category",
  "This category loaded successfully, but no published flashcards are available yet.",
  "Flashcard cards failed to load. Please try again.",
  "Preparing flashcard slideshow",
  "Keep this dialog open while we prepare the selected cards.",
  "Preparing game levels",
  "Choose a level after we prepare the game options for these flashcards.",
  "Keep this dialog open while we prepare the level choices.",
  "Preparing flashcard game",
  "Keep this screen open while we prepare your flashcard game.",
  "Choose one selected card, at least twelve selected cards, or clear the collection to use the whole category.",
  "Failed to start the flashcard game.",
  "Clear all",
  "Close",
  "Remove",
  "My flashcard collection",
  "Selected cards will be reused by slideshow and gameplay.",
  "No flashcards have been added to the collection yet.",
  "Close slideshow",
  "Show previous image",
  "Show next image",
  "Flashcard game levels",
  "If you selected cards manually, keep either one card or at least twelve cards to match the legacy game-entry rule.",
  "The current selection is too small for legacy gameplay. Add more selected cards or clear the collection to use the whole category.",
  "Basic",
  "Advanced",
  "Pro",
  "basic",
  "advanced",
  "pro",
  "Close flashcard game",
  "Flashcard game progress",
  "Flashcard game",
  "Flashcard game - {{level}}",
  "No prompt available",
  "Close this dialog and start a new game session from the flashcards collection.",
  "Return to flashcards",
  "Round complete. Keep the momentum going with another set of cards.",
  "Flashcard game completed",
  "Correct",
  "Incorrect",
  "Total prompts",
  "YOUR ROUND",
  "{{percent}}% accuracy",
  "{{correct}} of {{total}} prompts answered correctly.",
  "Learning complete",
  "Match",
  "Choose a match",
  "Check matches",
  "Your answer",
  "Check answer",
  "Use the microphone when supported, or type the answer as a fallback.",
  "Flashcard prompt",
  "Say or type the flashcard title",
  "Listening...",
  "Use mic",
  "Choose the translation for \"{{label}}\".",
  "Choose the word that matches \"{{label}}\".",
  "Listen and choose the correct flashcard.",
  "Look at the image and choose the correct flashcard.",
  "Choose the correct sound for \"{{label}}\".",
  "Choose the correct image for \"{{label}}\".",
  "Match each word with its translation.",
  "Arrange the letters to rebuild the word.",
  "Type the flashcard title",
  "Audio clue",
  "Image clue",
  "Translation clue",
  "Listen, then say or type the flashcard title.",
  "Listen and type the flashcard title.",
  "Look at the image, then say or type the flashcard title.",
  "Look at the image and type the flashcard title.",
  "Say or type the word for \"{{label}}\".",
  "Type the word for \"{{label}}\".",
  "No flashcards are available for this game session.",
  "A premium activation is required for this difficulty.",
  "Audio controls",
  "Pause audio",
  "Audio progress",
  "Audio settings",
  "Stop looping audio ({{count}} remaining)",
  "Loop audio {{count}} times",
  "No content available yet"
] as const

export type LearningUiLabel = (typeof learningUiLabels)[number]
export type LearningUiValues = Readonly<Record<string, string | number>>
export type LearningUiTranslator = (label: LearningUiLabel, values?: LearningUiValues) => string

export const formatLearningUiEnglish: LearningUiTranslator = (label, values = {}) => (
  label.replace(/\{\{(\w+)\}\}/g, (token, name: string) => String(values[name] ?? token))
)
